import React from 'react'
import PropTypes from 'prop-types'
import HighCharts from 'highcharts-react-official'
import highchartsPieInstance from './highchartsPieInstance'
import { GlobalStyle, Root } from './PieChart.styles'

/**
 * The PieChart's component.
 */
const PieChart = props => {
  const { data, hoverColor, id, minSize, tooltipFormatter, size, spacing } = props
  const options = {
    accessibility: {
      enabled: true,
      keyboardNavigation: {
        enabled: true,
        focusBorder: {
          style: {
            lineWidth: 3,
            color: 'black',
            borderRadius: 5
          },
          margin: 4
        }
      }
    },
    chart: {
      height: 337,
      marginBottom: 30,
      spacing: spacing || [0, 0, 0, 0],
      type: 'variablepie',
      style: {
        fontFamily: 'Roboto',
        fontSize: '18px',
        fontWeight: '400'
      }
    },
    series: [
      {
        data,
        innerSize: size,
        minPointSize: minSize,
        zMin: 0
      }
    ],
    plotOptions: {
      variablepie: {
        allowPointSelect: true,
        cursor: 'pointer',

        point: {
          accessibility: {
            enabled: true,
            description: 'Resumen de Ordenes de compra'
          },
          keyboardNavigation: {
            enabled: true
          },
          events: {
            mouseOver() {
              this.originalColor = this.color
              this.update({ color: hoverColor })
            },
            mouseOut() {
              this.update({ color: this.originalColor })
            }
          }
        }
      }
    },
    title: { text: '' },
    tooltip: {
      formatter: tooltipFormatter,
      style: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: '400'
      }
    }
  }

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={highchartsPieInstance} options={options} />
      </Root>
    </>
  )
}

PieChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      y: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      z: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ).isRequired,
  hoverColor: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  minSize: PropTypes.string,
  tooltipFormatter: PropTypes.func.isRequired,
  size: PropTypes.string,
  spacing: PropTypes.oneOfType([PropTypes.number])
}

export default PieChart
